var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ecircular-preview-container email-preview" },
    [
      _c(
        "div",
        { staticClass: "email-preview__content" },
        [
          _vm.isOldECircularPreview || _vm.isVendorEcircular
            ? _c("ECircularDescriptionView", {
                attrs: { ecircular: _vm.privateECircular },
              })
            : _c("ECircularPreview", {
                attrs: { dataSrc: _vm.parsedECircular },
              }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }